import _ from 'lodash';
import { create } from 'zustand';
import { SavedList } from '~/clientApi/savedLists.model';
import { ICreator } from '~/types';

export interface IUseSavedListsStore {
  creators: ICreator[];
  lists: SavedList[];

  isModalOpen: boolean;
  setIsModalOpen: (isModalOpen: boolean) => void;

  saveLists: (lists: SavedList[]) => void;
  toggleCreator: (creator: Partial<ICreator>, isChecked: boolean) => void;
  toggleAllCreators: (creator: Partial<ICreator[]>, isChecked: boolean) => void;
  newSavedListName: string;
  savedNewSavedListName: (savedListName: string) => void;
  clearStore: () => void;
  setCreators: (creators: ICreator[]) => void;
}

export const useSavedListsStore = create<IUseSavedListsStore>((set) => ({
  creators: [],
  toggleCreator: (creator: Partial<ICreator>, isChecked: boolean) =>
    set((state) => {
      if (isChecked) {
        return {
          creators: state.creators.concat(creator as ICreator),
        };
      }

      const filteredCreators = state.creators.filter(
        (c) => c.id !== creator.id,
      );

      return { creators: filteredCreators };
    }),
  toggleAllCreators: (creators: Partial<ICreator[]>, isChecked: boolean) =>
    set((state) => {
      const allCreators = state.creators.concat(creators as ICreator[]);
      const uniqueCreators = allCreators.filter(
        (v, i, a) => a.map((c) => c.id).indexOf(v.id) === i,
      );

      if (isChecked) {
        return {
          creators: uniqueCreators,
        };
      }

      return {
        creators: [],
      };
    }),
  saveLists: (lists: SavedList[]) => set(() => ({ lists })),
  lists: [],
  newSavedListName: '',
  savedNewSavedListName: (newSavedListName: string) =>
    set(() => ({ newSavedListName })),
  clearStore: () =>
    set(() => ({ newSavedListName: '', lists: [], creators: [] })),

  isModalOpen: false,
  setIsModalOpen: (isModalOpen) => set({ isModalOpen }),
  setCreators: (creators: ICreator[]) => set({ creators }),
}));
